import React from 'react';
import { Box, Typography } from '@mui/material';
import { glassSx, mvkgTokens } from '../../theme/mvkgTokens';

/** Segmented control in glass pill — matches prototype People/Library tabs. */
export default function GlassSegmented({ value, onChange, options }) {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        p: 0.75,
        gap: 0.5,
        borderRadius: `${mvkgTokens.radius.md}px`,
        ...glassSx(true),
      }}
    >
      {options.map((opt) => {
        const active = value === opt.id;
        return (
          <Box
            key={opt.id}
            component="button"
            type="button"
            onClick={() => onChange(opt.id)}
            sx={{
              border: 'none',
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1,
              px: 2,
              py: 1.25,
              borderRadius: `${mvkgTokens.radius.sm}px`,
              bgcolor: active ? 'primary.main' : 'transparent',
              color: active ? 'primary.contrastText' : 'text.primary',
              boxShadow: active ? mvkgTokens.shadow.brand : 'none',
              transition: 'all 0.15s',
              fontWeight: 700,
              fontSize: '0.8rem',
            }}
          >
            {opt.icon}
            <span>{opt.label}</span>
            {opt.count != null && (
              <Typography
                component="span"
                sx={{
                  fontFamily: mvkgTokens.font.mono,
                  fontSize: '0.65rem',
                  fontWeight: 800,
                  opacity: active ? 0.9 : 0.6,
                }}
              >
                {opt.count}
              </Typography>
            )}
          </Box>
        );
      })}
    </Box>
  );
}
